import "./NlpSideBarCustomerItem.css";
import React, {useEffect, useState} from "react";

const NlpSideBarCustomerItem: React.FC = () => {

    return (
        <div className="NlpSideBarCustomerItem">

        </div>
    );
};

export default NlpSideBarCustomerItem;
